module.exports = __webpack_public_path__ + "media/images/ads/creators_mobile-7dd9d8f35ffb7491a17452f3425a153b.png";